import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ImageZoomProps
 */

/**
 * ImageZoom ImageZoom.
 * @extends {Base<ImageZoomProps>}
 */
export default class ImageZoom extends Base {
  unZoomed = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ImageZoom',
  };

  /**
   * Get Height of element
   * @returns {string}
   */
  get imgHeight() {
    return this.$el.clientHeight;
  }

  /**
   * Get Height of viewport
   * @returns {string}
   */
  get viewportHeight() {
    return window.innerHeight;
  }

  /**
   * Click on image
   */
  onClick() {
    if (this.unZoomed) {
      this.unZoomed = false;
      this.$el.classList.remove('!cursor-zoom-in');
      this.$el.style.transform = `scale(1)`;
    } else {
      this.unZoomed = true;
      const scale = this.viewportHeight / this.imgHeight;
      this.$el.style.transform = `scale(${scale})`;
      this.$el.classList.add('!cursor-zoom-in');
    }
  }
}
